import {NgModule} from '@angular/core';
import {SymbolDecimalsService} from './symbol-decimals.service';

@NgModule({
    providers: [
        SymbolDecimalsService
    ]
})
export class SymbolDecimalsModule {}
